import AbstractStorage from './AbstractStorage';

class CookieStorage extends AbstractStorage {

    static checkSupport() {
        if (AbstractStorage.prototype.getCookieStorageSupport) {
            return AbstractStorage.prototype.getCookieStorageSupport.call(this);
        }        
    }

    static setItem(cname, cvalue, exdays) {

        if (!exdays) {
            exdays = 365;
        }

        var d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";

    }

    static getItem(cname) {
        var name = cname + "=";
        var decodedCookie = decodeURIComponent(document.cookie);
        var ca = decodedCookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return null;
    }

    static unsetItem(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    static clear() {
        var cookies = document.cookie.split(";");

        for (var i = 0; i < cookies.length; i++) {
            var cookie = cookies[i];
            var eqPos = cookie.indexOf("=");
            var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
        }
    }
}

export default CookieStorage;


// WEBPACK FOOTER //
// ./src/components/DeviceStorage/CookieStorage.js